/** Задержка перед показом плашки пустой области, чтобы не мигать при быстром перемещении карты */
export const SHOW_TIMEOUT = 1500;

export const NOT_FOUND_TOAST_TEST_ID = 'NotFoundToast';

/** Отступ тоста, поднятого над кнопкой «Список»: 12px отступ кнопки + 48px высота + 12px зазор */
export const RAISED_TOAST_INDENT = '72px';

/** Стандартный отступ десктопного тоста в ui-kit. Передаём явно: ui-kit не сбрасывает ранее заданный отступ */
export const DEFAULT_TOAST_INDENT = 'var(--unit_6)';

export const PORTRAIT_MEDIA_QUERY = '(orientation: portrait)';
